import React, { ReactNode } from 'react';

type ContextMenuContainerProps = {
  contextMenu?: ReactNode;
  children: ReactNode;
};

export function ContextMenuContainer({ contextMenu, children }: ContextMenuContainerProps) {
  return (
    <div className="context-menu__container">
      <div className="context-menu__content">{children}</div>
      {contextMenu && <div className="context-menu__context-button-container">{contextMenu}</div>}
    </div>
  );
}
